export var TeamLiveRequestsManagementEmployerRoutes = {
    "/absence-requests-v1/:request_id?brand_id&active_tab&user_id&start_date&end_date": {
        "loginRequired": true,
        "name": "appLayout.schedule.absence-requests-v1",
        "reloadOnSearch": false,
        "params": {
            "request_id": {
                value: null,
                dynamic: true
            },
            "start_date": {
                dynamic: true
            },
            "end_date": {
                dynamic: true
            }
        },
        "type": "frontend",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "views": {
            "body": {
                "component": "tsEmployerAbsenceRequestsComponent"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests-management-employer.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests-management-shared.module.js");
                }
            }
        ]
    },
    "/sickness-requests-v2/:request_id?brand_id&active_tab&user_id": {
        "loginRequired": true,
        "name": "appLayout.schedule.sickness-requests-v2",
        "reloadOnSearch": false,
        "params": {
            "request_id": {
                value: null,
                dynamic: true
            }
        },
        "type": "frontend",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "views": {
            "body": {
                "component": "tsEmployerSicknessRequestsComponent"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests-management-employer.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests-management-shared.module.js");
                }
            }
        ]
    },
    "/time-off?user&sortBy&startOn&position&category&status&active_tab&user_id": {
        "loginRequired": true,
        "name": "appLayout.schedule.time-off",
        "showGlobalSearch": true,
        "type": "frontend",
        "reloadOnSearch": false,
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "views": {
            "body": {
                'component': 'tsEmployerTimeOffComponent'
            }
        },
        "onEnter": ['hUser', 'userPermissions', function (hUser, userPermissions) {
            userPermissions.getBrandPolicy(hUser.getUserContext().brand_id)
                .then(function(policyParser) {
                    var hasAccessToTeam = policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);
                    if (!hUser.isTeamSchedulingEnabled() && !hasAccessToTeam) {
                        hRedirect('/dashboard');
                    }
                });


            $('body').addClass('availability-page');
        }],
        "onExit": function () {
            $('body').removeClass('availability-page');
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests-management-employer.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests-management-shared.module.js");
                }
            }
        ]
    },
    "/approved-requests?user_id": {
        "loginRequired": true,
        "name": "appLayout.schedule.approved-requests",
        "showGlobalSearch": true,
        "type": "frontend",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "views": {
            "body": {
                'component': 'tsEmployerApprovedRequestsComponent'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests-management-employer.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./team-live-requests-management-shared.module.js");
                }
            }
        ]
    },
};